import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
} from "react";

import { masterUrls } from "../../apiService/urls";
import useFetchData from "../../hooks/http/useFetchData";
import useUser from "../../hooks/user/useUser";
import { loadLocalState, saveLocalState } from "../../utils/localstorage";

const MasterContext = createContext({
  value: [false, {}, false],
  actions: {},
  attendance_state: {},
});

export const useMasterValues = () => {
  return useContext(MasterContext).value;
};

export const useMasterActions = () => {
  return useContext(MasterContext).actions;
};

// 🔥 NEW HOOK FOR GLOBAL ATTENDANCE STATE
export const useAttendanceState = () => {
  return useContext(MasterContext).attendance_state;
};

const MasterData = ({ children }) => {
  const { token, role } = useUser()[0];
  const userRole = role?.id ?? "";

  const [state, { setUrl, reload }] = useFetchData();

  // ✅ API DATA
  const data = state?.data ?? {};

  // 🔥 GLOBAL ATTENDANCE STATE (SOURCE OF TRUTH = API)
  const attendance_state = {
    isAttendance: data?.cur_attendance?.attendance ?? false,
    current_project: data?.cur_attendance?.current_project || "",
    isImmediateVisit: !!data?.cur_attendance?.current_project,
    isHeadOffice: data?.cur_attendance?.is_head_office ?? false,
    isMccEvent: data?.cur_attendance?.is_mcc_event ?? false,
  };

  // ✅ FETCH MASTER DATA
  useEffect(() => {
    if (token) {
      setUrl(`${masterUrls.activeMaster}?date=${new Date().toISOString()}`);
    }
  }, [token, userRole]);

  // ✅ RELOAD FUNCTION (used after submit)
  const reloadMaster = useCallback(() => {
    reload(masterUrls.activeMaster);
  }, [reload]);

  // 🔥 OPTIONAL: Sync to localStorage (for fallback only)
  useEffect(() => {
    if (data?.cur_attendance) {
      const logged_info = loadLocalState() || {};

      const updated = {
        ...logged_info,
        attendance: attendance_state.isAttendance,
        current_project: attendance_state.current_project,
        immediate_visit: attendance_state.isImmediateVisit,
        head_office: attendance_state.isHeadOffice,
        mcc_event: attendance_state.isMccEvent,
      };

      saveLocalState(updated);
    }
  }, [data]);

  // 🔥 CLEAR when logout
  useEffect(() => {
    if (!token) {
      const logged_info = loadLocalState() || {};

      const cleared = {
        ...logged_info,
        attendance: false,
        current_project: "",
        immediate_visit: false,
        head_office: false,
        mcc_event: false,
      };

      saveLocalState(cleared);
    }
  }, [token]);

  return (
    <MasterContext.Provider
      value={{
        value: [state.fetching, data, state.error],
        actions: {
          reload: reloadMaster,
        },
        attendance_state, // 🔥 GLOBAL ACCESS
      }}
    >
      {children}
    </MasterContext.Provider>
  );
};

export default MasterData;